module.exports = __webpack_public_path__ + "img/verified.7a0423bd.svg";